export const useImageUrl = (id: number, size: "small" | "medium" | "large") => {
  const baseUrl = useBaseUrl();
  return `${baseUrl.value}images/${id}?size=${size}`;
};
